export const KYC_CONTRACT_ADDRESS = "0x0D1927E2b54b0D91A57f74C05dF779802F7110cE";

//mainnet contracts : 
export const FAKT_CONTRACT_ADDRESS = "0xC3FFbE26E9446aC52008FfC8C1191d60A12bdC48";
export const STAKING_CONTRACT_ADDRESS = "0x3b3199AD1180DB635904E129020C164E06697b8c";
